export default class Bubble {
    constructor(adapter = {
        title:'',
        value:''
    }) {
        this.title = adapter.title || ''
        this.value = adapter.value || ''
    }
}



// WEBPACK FOOTER //
// ./src/Utils/Bubble.js